import styled from 'styled-components';

export const Overlay = styled.aside`
  background:  rgba(0,0,0,.8);
  height: 100vh;
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0.49')};
  position: fixed;
  right: 0;
  top:0;
  width: 100vw;
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  z-index: 1000;
`;

export const DrawerContainer = styled.div`
    background-color: #fff;
    box-shadow: 0px, 4px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    left: 0;
    max-width: 296px;
    overflow: hidden auto;
    padding: 56px 16px 24px;
    position: fixed;
    top: 0;
    transform: translateX(${({ isOpen }) => (isOpen ? '0%' : '-100%')});
    transition: transform .3s ease-in-out 0s;
    width:  80%;
    visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
    z-index: 1040;
`;
